import { defineComponent } from "vue";
import InputWidget from "./InputWidget";

export default defineComponent({
    components: {
        InputWidget,
    },

    template: `
        <InputWidget :label="label" :required="required" class="InputCheckbox" :class="{ 'InputCheckbox--checked': modelValue, 'InputCheckbox--multi': !single, 'InputCheckbox--error': error }">
            <label class="InputCheckbox__label">
                <span class="InputCheckbox__icon" tabindex="0" @click="onClick" @keydown.space="onClick" @keydown.enter="onClick">
                    <svg v-if="modelValue && single" class="InputCheckbox__check" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8072 6.20158C17.0641 6.47054 17.0643 6.90683 16.8076 7.17606L8.58847 15.7979C8.46518 15.9273 8.2979 16 8.12345 16C7.94901 16 7.78169 15.9274 7.65834 15.7982L5.19259 13.2142C4.9358 12.9451 4.9358 12.5088 5.19259 12.2397C5.44937 11.9706 5.8657 11.9706 6.12248 12.2397L8.12305 14.3362L15.8773 6.20206C16.1339 5.93284 16.5503 5.93262 16.8072 6.20158Z" fill="#005537"/>
                    </svg>

                    <svg v-if="modelValue" class="InputCheckbox__uncheck" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M5 11H16.5" stroke="#005537"/>
                    </svg>
                </span>

                <input type="checkbox" :checked="modelValue" @input="$emit('update:modelValue', $event.target.checked)" class="InputCheckbox__input" :required="required" />

                <span class="InputCheckbox__text" v-html="title"></span>
            </label>
        </InputWidget>
    `,

    emits: [
        'update:modelValue',
    ],

    props: {
        modelValue: { type: Boolean },
        single: { type: Boolean, default: true },
        label: { type: String },
        title: { type: String },

        error: { type: String },

        required: { type: Boolean },
    },

    methods: {
        onClick(e: MouseEvent) {
            e.preventDefault();

            this.$emit('update:modelValue', !this.modelValue);
        },
    },
});
